import { SiteContextService } from './../site-context.service';
import { IdentityService } from './../identity/identity.service';
import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class HasSiteGuard {
  constructor(
    protected readonly identityService: IdentityService,
    protected readonly router: Router,
    private readonly siteContext: SiteContextService,
  ) {}
  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentSite = await this.siteContext.getCurrentSiteAsync();
    if (!currentSite) {
      this.router.navigate(['account'], {
        queryParams: { callbackUrl: state.url },
      });
      return false;
    }
    return true;
  }
}
